export const subGroupsPositionEnum = {
    bottom: 'BOTTOM',
    top: 'TOP'
}
